import React, { Component, useMemo } from 'react';
import { bindActionCreators } from '@reduxjs/toolkit'
import { connect } from 'react-redux'
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonSelect,
  IonSelectOption,
  IonItem,
  IonLabel,
  IonTextarea,
  IonCheckbox,
  IonGrid,
  IonRow,
  IonCol,
  IonInput,
} from '@ionic/react';
import { v4 as uuidv4 } from 'uuid'; // For generating conversation_id
import methods from '../reducers/methods'
import BotHelper from '../helpers/BotHelper'; // Import the BotHelper for query function

class StreamingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessionInfo: null,
      peerConnection: null,
      taskInput: '',
      status: '',
      mediaCanPlay: false,
      removeBG: false,
      selectedAvatar: null,
      selectedVoice: null,
      selectedBotId: '9d6c1d9b-1234-4f6d-93a8-4567bcde1234',
      conversation_id: uuidv4(), // Generate a unique conversation ID for the session
      isListening: false, // To track whether the system is listening
      recognition: null,  // To store the SpeechRecognition instance
      isSessionActive: false, // To track if the session is active
    };


    this.SERVER_URL = 'https://api.heygen.com'; // Example server URL
    this.apiKey = 'NDVkNGVlZmIxYmRjNDRjMmJmNTMwYzFkNmEyYmFkNzAtMTcyNzM0MjQwMw=='; // Example API Key, replace with a real one
    // panote's key: NzFjY2I5Yzg5ZmFmNDJhYmJiOTUzODFiNmJmZDA4ZGEtMTcyNjU3NjgzMg==
    // lavender's key: NDVkNGVlZmIxYmRjNDRjMmJmNTMwYzFkNmEyYmFkNzAtMTcyNzM0MjQwMw==
  }

  avatarOptions = [
    { id: 'ef08039a41354ed5a20565db899373f3', name: 'Rebecca' },
    { id: '43c34c4285cb4b6c81856713c70ba23b', name: 'Rasmus' },
    { id: '336b72634e644335ad40bd56462fc780', name: 'Susan' },
    { id: '73c84e2b886940099c5793b085150f2f', name: 'Casual Female' },
  ];

  voiceOptions = [
    { id:'e23c82c61d934fa2b7fbda39a2247228', name: 'Male Gruffy' },
    { id:'42d598350e7a4d339a3875eb1b0169fd', name: 'Male Normal'},
    { id:'45980606751346deaf6415a2ba6cdfde', name: 'Female Young'}

  ];

  botOptions = [
    { id: '9d6c1d9b-1234-4f6d-93a8-4567bcde1234', name: 'Alex (Moderate Depression)' },
    { id: 'a4f7f89e-5678-48c7-bd3a-87d2fced5678', name: 'John (Alcoholism)' },
    { id: '31f93d4c-9fcd-4f3f-b5f8-82844d61259b', name: 'Sam (Drug Addiction)' },
    { id: '6b3a9c85-e017-4dd4-9e91-d01c1d4f8540', name: 'Laura (Schizophrenia)' },
    { id: '8c561a1e-55cf-47d9-9b98-f88d4f9fd524', name: 'David (PTSD)' },
    { id: '73fa6f4e-78cb-46d9-bc5b-4f0aee4c67ad', name: 'Mia (Anxiety Disorder)' },
  ];

  componentDidMount() {
    if (this.state.mediaCanPlay) {
      document.querySelector('#bgCheckboxWrap')?.classList.remove('hide');
    }
    // Initialize speech recognition
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      const recognition = new SpeechRecognition();
      recognition.continuous = false; // or true if you want to keep listening
      recognition.interimResults = false;
      recognition.lang = 'en-US'; // Set your desired language
      recognition.onstart = () => this.setState({ isListening: true });
      recognition.onend = () => this.setState({ isListening: false });
      recognition.onerror = (event) => this.updateStatus(`Speech recognition error: ${event.error}`);
      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        this.setState({ taskInput: transcript }); // Set the recognized text to taskInput
        this.updateStatus(`Recognized: ${transcript}`);
        this.talkHandler(); // Send the recognized text
      };

      this.setState({ recognition });
    } else {
      this.updateStatus('Speech recognition is not supported in this browser.');
    }
  }

  startListening() {
    if (this.state.recognition && !this.state.isListening) {
      this.state.recognition.start();
      this.updateStatus('Listening...');
    }
  }

  stopListening() {
    if (this.state.recognition && this.state.isListening) {
      this.state.recognition.stop();
      this.updateStatus('Stopped listening');
    }
  }

  updateStatus(message) {
    this.setState((prevState) => ({
      status: prevState.status + message + '\n',
    }));
  }

  async startConversation() {
    this.updateStatus('Starting conversation... please wait');

    const { selectedAvatar, selectedVoice } = this.state;

    if (!selectedAvatar || !selectedVoice) {
      this.updateStatus('Please select both Avatar and Voice');
      return;
    }

    try {
      // Create a new session
      const response = await fetch(`${this.SERVER_URL}/v1/streaming.new`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Api-Key': this.apiKey,
        },
        body: JSON.stringify({
          quality: 'low',
          avatar_name: selectedAvatar,
          voice: {
            voice_id: selectedVoice,
            //voice_id: '',
            emotion:'Serious',
            "rate": 1.0
          },
          
        }),
      });
      const data = await response.json();
      if (!data.data) throw new Error('Failed to create session');

      // Set the session info
      this.setState({
        sessionInfo: data.data,
      });
      this.updateStatus('Session created successfully');

      // Start the session
      const peerConnection = new RTCPeerConnection({
        iceServers: data.data.ice_servers2,
      });

      peerConnection.ontrack = (event) => {
        if (event.track.kind === 'audio' || event.track.kind === 'video') {
          const mediaElement = document.querySelector('#mediaElement');
          mediaElement.srcObject = event.streams[0];
        }
      };

      peerConnection.ondatachannel = (event) => {
        const dataChannel = event.channel;
        dataChannel.onmessage = this.onMessage.bind(this);
      };

      peerConnection.onicecandidate = ({ candidate }) => {
        if (candidate) {
          this.handleICE(data.data.session_id, candidate.toJSON());
        }
      };

      peerConnection.oniceconnectionstatechange = () => {
        this.updateStatus(`ICE connection state changed to: ${peerConnection.iceConnectionState}`);
      };

      const remoteDescription = new RTCSessionDescription(data.data.sdp);
      await peerConnection.setRemoteDescription(remoteDescription);

      const localDescription = await peerConnection.createAnswer();
      await peerConnection.setLocalDescription(localDescription);

      await this.startSession(data.data.session_id, localDescription);

      this.setState({ peerConnection, isSessionActive: true });
      this.updateStatus('Conversation started successfully');
    } catch (error) {
      console.error('Error starting conversation:', error);
      this.updateStatus('Error starting conversation');
    }
  }


  async handleICE(session_id, candidate) {
    try {
      const response = await fetch(`${this.SERVER_URL}/v1/streaming.ice`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Api-Key': this.apiKey,
        },
        body: JSON.stringify({ session_id, candidate }),
      });
      const data = await response.json();
      if (data) {
        this.updateStatus('ICE candidate sent successfully');
      } else {
        throw new Error('Failed to send ICE candidate');
      }
    } catch (error) {
      console.error('Error sending ICE candidate:', error);
      this.updateStatus('Error sending ICE candidate');
    }
  }

  async startSession(session_id, sdp) {
    try {
      const response = await fetch(`${this.SERVER_URL}/v1/streaming.start`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Api-Key': this.apiKey,
        },
        body: JSON.stringify({ session_id, sdp }),
      });
      const data = await response.json();
      if (!data) {
        throw new Error('Failed to start session');
      }
    } catch (error) {
      console.error('Error starting session:', error);
      this.updateStatus('Error starting session');
    }
  }

  onMessage(event) {
    const message = event.data;
    console.log('Received message:', message);
  }

  async talkHandler() {
    if (!this.state.sessionInfo) {
      this.updateStatus('Please create a connection first');
      return;
    }

    const { taskInput, selectedBotId, conversation_id, sessionInfo } = this.state;

    if (taskInput.trim() === '') {
      return;
    }

    try {
      // Call the BotHelper function to get the LLM response
      const response = await BotHelper.queryPdfBot(taskInput, selectedBotId, conversation_id);

      if (response?.response?.answer_text) {
        this.updateStatus(`LLM response: ${response.response.answer_text}`);

        // Send the LLM response to the streaming session using the botTalk function
        await this.botTalk(sessionInfo.session_id, response.response.answer_text);
      } else {
        this.updateStatus('Failed to get a response from AI');
      }
    } catch (error) {
      console.error('Error talking to AI:', error);
      this.updateStatus('Error talking to AI');
    }
  }

  async botTalk(session_id, text) {
    try {
      const response = await fetch(`${this.SERVER_URL}/v1/streaming.task`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Api-Key': this.apiKey,
        },
        body: JSON.stringify({ session_id, text }),
      });
      if (response.status === 500) {
        console.error('Server error');
        this.updateStatus('Server Error. Please ask the staff if the service has been turned on');
        throw new Error('Server error');
      } else {
        const data = await response.json();
        return data.data;
      }
    } catch (error) {
      console.error('Error in bot Talk function:', error);
      this.updateStatus('Error sending text to stream');
    }
  }

  async closeConnectionHandler() {
    if (!this.state.sessionInfo) {
      this.updateStatus('Please create a connection first');
      return;
    }

    try {
      const { peerConnection, sessionInfo } = this.state;
      if (peerConnection) peerConnection.close();
      const response = await fetch(`${this.SERVER_URL}/v1/streaming.stop`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Api-Key': this.apiKey,
        },
        body: JSON.stringify({ session_id: sessionInfo.session_id }),
      });
      const data = await response.json();
      if (data.data) {
        this.updateStatus('Connection closed successfully');
        this.setState({ sessionInfo: null, peerConnection: null, isSessionActive: false });
      } else {
        throw new Error('Failed to close connection');
      }
    } catch (error) {
      console.error('Error closing connection:', error);
      this.updateStatus('Error closing connection');
    }
  }
  render() {
    const styles = {
      main: {
        padding: '16px',
      },
      videoWrap: {
        position: 'relative',
        width: '100%',
        height: 'auto',
        backgroundColor: 'black',
      },
      videoEle: {
        width: '100%',
        height: 'auto',
      },
      hide: {
        display: 'none',
      },
      show: {
        display: 'block',
      },
    };

    return (
      <React.Fragment>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Streaming Page</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          {/* Inline CSS */}
          <style>
            {`
              .videoEle {
                width: 100%;
                height: auto;
              }

              .hide {
                display: none;
              }

              .show {
                display: block;
              }
            `}
          </style>
          <IonGrid fixed={true}>
            <IonRow>
              {/** divide the section into video and control panel */}
              {/** Video Panel */}
              <IonCol size="8">
                <div style={styles.videoWrap}>
                  <video
                    id="mediaElement"
                    style={styles.videoEle}
                    autoPlay
                    onLoadedMetadata={() =>
                      this.setState({ mediaCanPlay: true })
                    }
                  ></video>
                  <canvas
                    id="canvasElement"
                    style={styles.hide}
                  ></canvas>
                </div>
              </IonCol>
              {/** Control Panel */}
              <IonCol>

                {/* First Row: Avatar and Voice Select Boxes */}
                <IonCol>
                  <IonItem>
                    <IonLabel position="stacked">AvatarID</IonLabel>
                    <IonSelect
                      value={this.state.selectedAvatar}
                      placeholder="Select Avatar"
                      onIonChange={(e) => this.setState({ selectedAvatar: e.detail.value })}
                    >
                      {this.avatarOptions.map((avatar) => (
                        <IonSelectOption key={avatar.id} value={avatar.id}>
                          {avatar.name}
                        </IonSelectOption>
                      ))}
                    </IonSelect>
                  </IonItem>
                </IonCol>


                <IonCol>
                  <IonItem>
                    <IonLabel position="stacked">VoiceID</IonLabel>
                    <IonSelect
                      value={this.state.selectedVoice}
                      placeholder="Select Voice"
                      onIonChange={(e) => this.setState({ selectedVoice: e.detail.value })}
                    >
                      {this.voiceOptions.map((voice) => (
                        <IonSelectOption key={voice.id} value={voice.id}>
                          {voice.name}
                        </IonSelectOption>
                      ))}
                    </IonSelect>
                  </IonItem>
                </IonCol>

                <IonCol>
                  <IonItem>
                    <IonLabel position="stacked">Bot Profile</IonLabel>
                    <IonSelect
                      value={this.state.selectedBotId}
                      placeholder="Select Bot Profile"
                      onIonChange={(e) => {
                        this.setState({ selectedBotId: e.detail.value })
                        this.state.status = ""
                      }}
                    >
                      {this.botOptions.map((bot) => (
                        <IonSelectOption key={bot.id} value={bot.id}>
                          {bot.name}
                        </IonSelectOption>
                      ))}
                    </IonSelect>
                  </IonItem>
                </IonCol>

                {/* Second Row: Start /close button */}
                <IonCol>
                  {!this.state.isSessionActive ? (
                    <IonButton expand="full" onClick={this.startConversation.bind(this)}>
                      Start Conversation
                    </IonButton>
                  ) : (
                    <IonButton expand="full" onClick={this.closeConnectionHandler.bind(this)}>
                      Close
                    </IonButton>
                  )}
                </IonCol>

                {/* Third Row: Message Input Box and Talk Button */}
                {this.state.isSessionActive && <React.Fragment>
                  <IonRow>
                    <IonCol size="8">
                      <IonItem>
                        <IonLabel position="stacked">Message</IonLabel>
                        <IonInput
                          id="taskInput"
                          type="text"
                          value={this.state.taskInput}
                          onIonChange={(e) =>
                            this.setState({ taskInput: e.detail.value })
                          }
                        />
                      </IonItem>
                    </IonCol>
                    <IonCol>
                      <IonButton expand="full" onClick={this.talkHandler.bind(this)}>
                        Send
                      </IonButton>
                    </IonCol>

                  </IonRow>
                  <IonCol>
                    <IonButton
                      expand="full"
                      onMouseDown={this.startListening.bind(this)}
                      onMouseUp={this.stopListening.bind(this)}
                      onTouchStart={this.startListening.bind(this)}
                      onTouchEnd={this.stopListening.bind(this)}
                    >
                      Long Press to Talk
                    </IonButton>
                  </IonCol>
                </React.Fragment>}

              </IonCol>
            </IonRow>


            {/* Status Display */}
            <IonRow>
              <IonCol>
                <IonTextarea
                  id="status"
                  value={this.state.status}
                  readonly
                  rows={10}
                ></IonTextarea>
              </IonCol>
            </IonRow>

            {/* Video and Canvas Elements */}
            {/*<IonRow>
              <IonCol>
                <div style={styles.videoWrap}>
                  <video
                    id="mediaElement"
                    style={styles.videoEle}
                    autoPlay
                    onLoadedMetadata={() =>
                      this.setState({ mediaCanPlay: true })
                    }
                  ></video>
                  <canvas
                    id="canvasElement"
                    style={styles.hide}
                  ></canvas>
                </div>
              </IonCol>
            </IonRow>*/}

            {/* Background Remove Option */}
            <IonRow>
              <IonCol>
                <IonItem id="bgCheckboxWrap" className="hide">
                  <IonLabel>Remove background</IonLabel>
                  <IonCheckbox
                    checked={this.state.removeBG}
                    onIonChange={(e) =>
                      this.setState({ removeBG: e.detail.checked })
                    }
                  />
                </IonItem>
                {/* <IonItem>
                  <IonLabel position="stacked">Background (CSS)</IonLabel>
                  <IonInput
                    id="bgInput"
                    type="text"
                    value='url("https://app.heygen.com/icons/heygen/logo_hori_text_light_bg.svg") center / contain no-repeat'
                  />
                </IonItem> */}
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
        </React.Fragment>
    );
  }
}
let StreamingPageContainer = props => {
  // const { dispatch, questionnaire, user, config } = props
  const { dispatch } = props

  const boundUserActionCreators = useMemo(() => bindActionCreators({
      // ...UserActions,
      // ...ConfigActions,
      // ...QuestionnaireActions,
      resetSession: methods.RESET_SESSION_ACTION
  }, dispatch), [dispatch])
  // const bountConfigActionCreators = useMemo(() => bindActionCreators(ConfigActions, dispatch), [dispatch])

  // console.log("home container props", bountUserActionCreators)
  return <StreamingPage
      // user={user}
      // config={config}
      // questionnaire={questionnaire}
      {...boundUserActionCreators} {...props} />
}

// SurveyContainer = connect(state => ({ ...state.questionnaireReducer, config: state.configReducer, user: state.userReducer }))(SurveyContainer)
StreamingPageContainer = connect(state => ({  }))(StreamingPageContainer)

export default StreamingPageContainer
// export default StreamingPage;